import { JsBridgeAndriod } from './andriod';
import { JsBridgeIOS } from './ios';
import { JsBridgeRN } from './reactNative';
import { JsBridge } from './js-bridge';
import { JsBridgeMock } from './mock';
import { getQueryVariable, isServer } from '../util';
import { jsBridgeProxy } from './js-bridge-proxy';

async function getJsBridge(): Promise<JsBridge> {
    try {
        const isIOS = getQueryVariable('o') === 'i';
        const isAndroid = getQueryVariable('o') === 'a';
        const isUpgrade = getQueryVariable('3in1') === 'rn';

        if (isServer) {
            console.log('------server-------');
            return new JsBridgeMock();
        } else if (isUpgrade || window.RNDiscoverJsBridge) {
            console.log('------RNDiscoverJsBridge------');
            if (window.RNDiscoverJsBridge) {
                return new JsBridgeRN();
            } else {
                console.log('------RNDiscoverJSBridgeReady------');
                // 如果 window.RNDiscoverJsBridge 不存在,添加 1 秒的延时器
                await new Promise((resolve) => setTimeout(resolve, 1000));
                return new JsBridgeRN();
            }
        } else if (window.webkit?.messageHandlers || isIOS) {
            console.log('------IOS------');
            return new JsBridgeIOS();
        } else if (window.AosDiscoverJsBridge || isAndroid) {
            console.log('------android------');
            return new JsBridgeAndriod();
        } else {
            return new JsBridgeMock();
        }
    } catch (err) {
        console.error('Error initializing JsBridge:', err);
        return new JsBridgeMock();
    }
}

const jsBridge = new jsBridgeProxy(await getJsBridge());
export { jsBridge };
